import { ReactElement } from 'react';
import { TextField, SelectField, useField } from '@ff-it/form';
import { Fieldset, FormInlineError } from 'components';
import { coerceEmptyToNull } from 'utilities';
import { Option } from 'options';

type HorizonSynchronizationStrategy = 'default' | 'mgroup';
const horizonSynchronizationStrategyOptions: Option<HorizonSynchronizationStrategy>[] = [
  { label: 'Default', value: 'default' },
  { label: 'MGroup', value: 'mgroup' },
];

const KEEP_HELP = 'Leave blank to keep current';

function useHasValue(name: string): boolean {
  const {
    input: { value },
  } = useField(name, { subscription: { value: true } });
  return Boolean(value);
}

export function HorizonConfigFields(): ReactElement {
  const passwordSet = useHasValue('horizon.password_set');
  const applicationKeySet = useHasValue('horizon.application_key_set');
  const applicationIdEntered = useHasValue('horizon.application_id');
  return (
    <Fieldset title="Horizon integration">
      <FormInlineError name="horizon" />
      <div className="row">
        <TextField name="horizon.endpoint" label="Sync endpoint" className="col-md-6" required {...coerceEmptyToNull} />
        <TextField
          name="horizon.organisation_pk"
          label="Organisation"
          className="col-md-6"
          required
          {...coerceEmptyToNull}
        />
        <TextField name="horizon.username" label="Username" className="col-md-6" required {...coerceEmptyToNull} />
        <TextField
          name="horizon.password"
          label="Password"
          className="col-md-6"
          required={!passwordSet}
          help={passwordSet ? KEEP_HELP : undefined}
          {...coerceEmptyToNull}
        />
        <TextField name="horizon.application_id" label="Application ID" className="col-md-6" {...coerceEmptyToNull} />
        <TextField
          name="horizon.application_key"
          label="Application key"
          className="col-md-6"
          required={applicationIdEntered && !applicationKeySet}
          help={applicationKeySet ? KEEP_HELP : undefined}
          {...coerceEmptyToNull}
        />
        <SelectField
          name="horizon.synchronization_strategy"
          label="Synchronization strategy"
          className="col-md-6"
          options={horizonSynchronizationStrategyOptions}
          required
          simple
        />
      </div>
    </Fieldset>
  );
}
